module.exports = __webpack_public_path__ + "img/Erfgoed-Leiden-en-Omstreken.7f068235.svg";